import { isNumber, isString } from "@root/shared/utils/typeGuard";
import { type Choice, type ChoiceGroup } from "./types";

export const convertToPopularAreaChoices = (popularAreas: string[][]): Choice[] => {
  return popularAreas.map(([label, value]) => ({
    id: `popular-area-${value}`,
    value,
    label,
  }));
};

export const convertToChoiceGroups = (
  groups: (string | number | null | (string | number)[][])[][],
): ChoiceGroup[] => {
  return groups.map((group) => {
    const [groupNameRaw, valueRaw, choicesRaw] = group;
    const groupName = isString(groupNameRaw) ? groupNameRaw : "その他";
    const groupValue = isString(valueRaw) || isNumber(valueRaw) ? String(valueRaw) : "";
    const choices = choicesRaw as (string | number)[][];

    return {
      groupName,
      value: groupValue,
      choices: choices.map(([label, value], index) => ({
        id: `${value}-${index}`,
        value: String(value),
        label: String(label),
      })),
    };
  });
};
